import { Button, Slide, Modal, TextField, Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import React from 'react';
import { MainContext } from '../../context';
import { useStyles } from './styles';
const Spotify = require('spotify-web-api-js');
const spotifyWebApi = new Spotify();

interface Props {
  show: boolean;
  setShow: (value: boolean) => void;
  playlist: any;
}

export const SaveToAccountModal = (props: Props) => {
  const [playlistName, setPlaylistName] = React.useState('');
  const [playlistDescription, setPlaylistDescription] = React.useState('');
  const [trackUris, setTrackUris] = React.useState([]);
  const classes = useStyles();
  const { accessToken, currentUser } = React.useContext(MainContext);

  React.useEffect(() => {
    if (accessToken) {
      spotifyWebApi.setAccessToken(accessToken);
    }

    let uriArray: any = [];
    props.playlist.map((track: any) => {
      uriArray.push(track.uri);
    });
    setTrackUris(uriArray);
  }, [props.playlist]);

  const savePlaylistToSpotify = () => {
    spotifyWebApi
      .createPlaylist(currentUser!.id, {
        name: playlistName,
        description: playlistDescription,
        public: false,
      })
      .then((playlist: any) => {
        props.setShow(false);
        spotifyWebApi.addTracksToPlaylist(playlist.id, trackUris).then((res: any) => console.log(res));
      });
  };

  const handleUpdatePlaylistName = (event: React.ChangeEvent<{ value: string }>) => {
    setPlaylistName(event.target.value);
  };

  const handleUpdatePlaylistDescription = (event: React.ChangeEvent<{ value: string }>) => {
    setPlaylistDescription(event.target.value);
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        open={props.show}
        onClose={() => props.setShow(false)}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Slide in={props.show} direction="up">
          <div className={classes.paper}>
            <Typography variant="h5" style={{ color: 'white' }}>
              Add Playlist to Spotify!
            </Typography>
            <TextField
              label="Playlist Name"
              autoFocus
              value={playlistName}
              onChange={handleUpdatePlaylistName}
              style={{ margin: 10, minWidth: 350 }}
            />
            <br />
            <TextField
              multiline
              rows={5}
              variant="outlined"
              label="Description"
              value={playlistDescription}
              onChange={handleUpdatePlaylistDescription}
              style={{ margin: 10, minWidth: 350 }}
            />
            <br />
            <Button
              onClick={() => props.setShow(false)}
              variant="contained"
              color="secondary"
              className={classes.cancelButton}
            >
              <CancelIcon style={{ marginRight: 10 }} />
              Cancel
            </Button>
            <Button
              onClick={() => savePlaylistToSpotify()}
              variant="contained"
              color="secondary"
              className={classes.button}
            >
              <CheckCircleIcon style={{ marginRight: 10 }} />
              Save to Account
            </Button>
          </div>
        </Slide>
      </Modal>
    </div>
  );
};
